"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2549 5c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25c.6903 0 1.25-.5596 1.25-1.25S17.9452 5 17.2549 5zm-3.25 1.25c0-1.795 1.4551-3.25 3.25-3.25s3.25 1.455 3.25 3.25-1.4551 3.25-3.25 3.25c-.9283 0-1.7656-.3892-2.3578-1.0132l-4.9725 2.8414A3.261 3.261 0 0 1 9.9941 12c0 .2303-.024.455-.0695.6718l4.9725 2.8414c.5922-.6241 1.4295-1.0132 2.3578-1.0132 1.7949 0 3.25 1.4551 3.25 3.25S19.0498 21 17.2549 21s-3.25-1.4551-3.25-3.25c0-.1448.0095-.2874.0278-.4272l-5.104-2.9166a3.238 3.238 0 0 1-2.1846.8438c-1.7949 0-3.25-1.4551-3.25-3.25s1.4551-3.25 3.25-3.25c.8411 0 1.6076.3195 2.1847.8438l5.1039-2.9166a3.2903 3.2903 0 0 1-.0278-.4272zm-7.2608 4.5c-.6903 0-1.25.5596-1.25 1.25s.5597 1.25 1.25 1.25c.6904 0 1.25-.5596 1.25-1.25s-.5596-1.25-1.25-1.25zM17.255 16.5c-.6904 0-1.25.5596-1.25 1.25s.5596 1.25 1.25 1.25c.6903 0 1.25-.5596 1.25-1.25s-.5597-1.25-1.25-1.25z"
  })];
};

exports.default = _default;